import { render, staticRenderFns } from "./navbar-user-actions.vue?vue&type=template&id=a349169c"
import script from "./navbar-user-actions.ts?vue&type=script&lang=ts&external"
export * from "./navbar-user-actions.ts?vue&type=script&lang=ts&external"
import style0 from "./navbar-user-actions.scss?vue&type=style&index=0&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a349169c')) {
      api.createRecord('a349169c', component.options)
    } else {
      api.reload('a349169c', component.options)
    }
    module.hot.accept("./navbar-user-actions.vue?vue&type=template&id=a349169c", function () {
      api.rerender('a349169c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/navbar/navbar-user-actions/navbar-user-actions.vue"
export default component.exports